import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-items-controls-footer',
    styleUrls: ['./items-controls-footer.component.scss'],
    templateUrl: './items-controls-footer.component.html'
})
export class ItemsControlsFooterComponent implements OnInit {

    @Input() disabled: boolean;
    @Input() consumer: any;
    @Input() featureScope: string;
    @Input() isLoading: boolean;
    @Input() location: any;
    @Input() submenu: string;
    @Input() showSaveButton: boolean;
    @Input() showNextButton = false;
    @Input() contentLoading = true;
    @Input() isDragAndDropEnabled;

    @Output() nextButtonClicked = new EventEmitter<void>();
    @Output() handleChange = new EventEmitter<boolean>();
    @Output() saveAssignments = new EventEmitter<void>();
    @Output() cancel = new EventEmitter<void>();

    constructor() {}

    ngOnInit(): void {
    }

    handleDragDropToggle(checked: boolean) {
        this.handleChange.next(checked);
    }

    handleSaveAssignments() {
        this.saveAssignments.next();
    }

    handleCancel() {
        this.cancel.next();
    }

    handleNextButtonClicked() {
        this.showNextButton = false;
        this.nextButtonClicked.next();
    }

}
